import { nonNullable, typeofBoolean } from '@banking/ui/utils/predicates';
export default function assert(condition, msg) {
  if (!condition) {
    throw new Error(msg ?? 'assertion failure');
  }
}
export function assertInstanceOf(val, ctor) {
  function assert(val, ctor) {
    if (!(val instanceof ctor)) {
      throw new TypeError(`Expected value to be an instance of ${ctor.name}.`);
    }
  }
  assert(val, ctor);
  return val;
}
export function assertBoolean(val) {
  assert(typeofBoolean(val), 'value must be boolean');
  return val;
}
export function assertNonNullable(val) {
  assert(nonNullable(val), 'value cannot be nullable');
  return val;
}